import { useTranslation } from 'react-i18next';
import { UserTextService } from '../services';

export function ShowEvaluationQuestion({ question, index }) {
  const { t } = useTranslation();
  const questioner = {
    __html: question
      ? UserTextService.removeEditableText(`
          ${index === 0 ? question.methodHeading || '' : ''}
          ${question.heading || ''}<br/>
          ${question.question1 || ''}<br/>
          ${
            question.question2
              ? `${question.question2} <br/> ${t('activity.evaluation.tell_us_more_two_ratings')}`
              : t('activity.evaluation.tell_us_more_one_rating')
          }
      `)
      : null,
  };

  return (
    <div
      className="show-evaluation-questions"
      dangerouslySetInnerHTML={questioner}
    />
  );
}

export default ShowEvaluationQuestion;
